import React from 'react';
import PropTypes from 'prop-types';
import {ALARM__24} from '@homeaway/svg-defs/lib/defs/ALARM__24';
import {SVGIcon} from '@homeaway/react-svg';
import translate from '../../../utils/translations';
import CountdownComp from '@homeaway/react-countdown';

import './Countdown.less';

export class Countdown extends React.PureComponent {
    static propTypes = {
        expirationDateTime: PropTypes.string,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const {expirationDateTime, translations} = this.props;

        if (!expirationDateTime) {
            return null;
        }

        return (
            <div className="Countdown-Section">
                <div className="Countdown-Section__alarm">
                    <SVGIcon markup={ALARM__24} />
                </div>
                <div>
                    <strong className="Countdown-Section__time">
                        <CountdownComp
                            expiration={new Date(expirationDateTime).getTime()}
                        />
                    </strong>
                    <div>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.countdown.timeLeft'
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
